import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MessagesRoutes } from '@core';
import { ChatComponent, ChatsListComponent } from './components';
import { isChannelLoadedGuard } from './application/guards';
import { isAuthedGuard } from '@auth';

const routes: Routes = [
  {
    path: MessagesRoutes.ROOT,
    children: [
      {
        path: MessagesRoutes.ROOT,
        component: ChatsListComponent,
        canActivate: [isAuthedGuard]
      },
      {
        path: MessagesRoutes.CHAT,
        component: ChatComponent,
        canActivate: [isChannelLoadedGuard, isAuthedGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MessagesRoutingModule {}
